import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import BookCard from "./BookCard";
import { useLang } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";

export default function BookCarousel({ title, books, seeAllTo }) {
  const scrollRef = useRef(null);
  const { t } = useLang();
  const navigate = useNavigate();

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: dir * 600, behavior: "smooth" });
  };

  if (!books?.length) return null;

  return (
    <section className="py-6">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-5">
          <h2 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight">{title}</h2>
          <div className="flex items-center gap-2">
            {seeAllTo && (
              <button
                onClick={() => navigate(seeAllTo)}
                className="text-sm font-medium text-brand-400 hover:text-brand-300 transition-colors mr-2"
              >
                {t("see_all")}
              </button>
            )}
            <button
              onClick={() => scroll(-1)}
              className="w-9 h-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-brand-500/50 transition-colors"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              onClick={() => scroll(1)}
              className="w-9 h-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-brand-500/50 transition-colors"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div ref={scrollRef} className="flex gap-5 overflow-x-auto no-scrollbar pb-2 scroll-smooth">
          {books.map((b) => (
            <BookCard key={b.id} book={b} />
          ))}
        </div>
      </div>
    </section>
  );
}
